import { render } from "./PageBuilder.vue?vue&type=template&id=f687f58a&bindings={\"addSection\":\"options\",\"create\":\"options\"}"
import script from "./PageBuilder.vue?vue&type=script&lang=js"
export * from "./PageBuilder.vue?vue&type=script&lang=js"

import "./PageBuilder.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script